export const styles = {
  button: {
    boxShadow: "unset!important",
    width: "100%!important",
  },
};
